import React from "react";
import styles from "./styles.module.scss";

const FooterV2: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.menu}>
        <a href="#topo" className={styles.logo} title="Parceiros Promo">
          <img
            src="/images-capa2/global/logo-roxo.svg"
            alt="Parceiros Promo"
            width={184}
            height={32}
          />
        </a>

        <div className={styles.right}>
          <nav className={styles.links}>
            <a href="/signin">Acesse sua conta</a>
            <a href="/termos/">Termos de Adesão</a>
            <a href="/politica-de-privacidade/">Políticas de Uso</a>
          </nav>

          <div className={styles.social}>
            <a
              href="https://www.facebook.com/profile.php?id=100091227527664"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <img src="/images-capa2/footer/facebook.png" alt="Facebook" />
            </a>
            <a
              href="https://www.instagram.com/parceirospromo/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <img src="/images-capa2/footer/instagram.png" alt="Instagram" />
            </a>
            <a
              href="https://www.youtube.com/@parceirospromo"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <img src="/images-capa2/footer/youtube.png" alt="YouTube" />
            </a>
          </div>
        </div>
      </div>

      <div className={styles.legal}>
        <p>
          Amo Promo | CNPJ: 73.690.653/0001-13 | Rua dos Timbiras, nº 2352, 6º
          andar - Belo Horizonte - MG © {new Date().getFullYear()} Parceiros
          Promo | By - Amopromo
        </p>
      </div>
    </footer>
  );
};

export default FooterV2;
